import { BC_HQ } from "app_constants";
import { ICON_TYPE } from "components/icons/icon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import type { ISectionProps } from "types/navigation";

const SUPERUSER: ISectionProps = {
  feature: "Superuser",
  icon: ICON_TYPE.SOLID_STAR_ICON,
  requiresSuperAdmin: true,
  path: "/superuser",
  level: ["store"],
  dateSupport: DateRangeSupport.NONE,
  subSections: [
    {
      feature: "Device Logs",
      app: BC_HQ,
      level: ["store"],
      scope: ["superuser"],
      path: "/superuser/device_logs",
      legacyPath: () => "/pos_device_logs",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Features",
      app: BC_HQ,
      level: ["store"],
      scope: ["superuser"],
      path: "/superuser/features",
      legacyPath: () => "/features",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Merchant Profile",
      app: BC_HQ,
      level: ["store"],
      scope: ["superuser"],
      path: "/superuser/merchant_profile",
      legacyPath: () => "/merchant_profile",
      dateSupport: DateRangeSupport.NONE,
    },
  ],
};

export default SUPERUSER;
